import LoadingViewerFragment from "@coworker/apprestructured/src/task-management/components/TaskViewerSheet/viewer-fragments/LoadingViewerFragment/LoadingViewerFragment";

export default LoadingViewerFragment;
